module.exports = __webpack_public_path__ + "media/images/icons/country_flags/kn-650b92794fb6826cea932164970c097e.svg";